import "intersection-observer";
import $ from "jquery";
import "jquery-match-height";
import "magnific-popup";

import "./libs/utility.js";
import "./libs/slider.js";
import "./libs/tab.js";

if (typeof window !== "undefined") {
  window.$ = $;
  window.jQuery = $;
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    // const isMobile = window.matchMedia("(max-width:767px)").matches;

    const windowHeight = $(window).height();

    if (windowHeight < 660) {
      $(".side-logo").remove();
      $(".side-menu").css("margin-top", 0);
    }

    $(".top-kawamura__video__link").magnificPopup({
      type: "inline",
      preloader: false,
    });

    //店舗一覧の開閉
    $(".top-locations__item__header").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

    //よくある質問の開閉
    $(".top-faq__item__q").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

    //ご入会の流れの開閉
    $(".top-flow-container-top").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

    // 電話モーダル
    $(function () {
      $(".fixedTel").magnificPopup({
        type: "inline",
      });
    });

    // お客様の声「もっと見る」ボタン（個別に開閉）
    $(".top-voice-slide__bottom").on("click", function (e) {
      e.preventDefault();
      const $button = $(this);
      const $slide = $button.closest(".top-voice-slide");
      const $text = $slide.find(".top-voice-slide__mid p");
      const isOpen = $button.hasClass("is-open");

      // このスライドのみを開閉（他のスライドには影響しない）
      if (isOpen) {
        $text.removeClass("is-open");
        $button.removeClass("is-open");
        $button.html(
          'もっと見る<span class="top-voice-slide__bottom__cross"></span>',
        );
      } else {
        $text.addClass("is-open");
        $button.addClass("is-open");
        $button.html(
          '閉じる<span class="top-voice-slide__bottom__cross"></span>',
        );
      }
    });

    // 料金プランの表自体をマウスでドラッグできるように
    mousedragscrollable('.top-price__table');
  },
  false,
);

function mousedragscrollable(element) {
  let target;
  const elms = document.querySelectorAll(element);
  for (let i = 0; i < elms.length; i++) {
    elms[i].addEventListener("mousedown", function (evt) {
      evt.preventDefault();
      target = elms[i];
      target.dataset.down = "true";
      target.dataset.move = "false";
      target.dataset.x = evt.clientX;
      target.dataset.y = evt.clientY;
      target.dataset.scrollleft = target.scrollLeft;
      target.dataset.scrolltop = target.scrollTop;
      evt.stopPropagation();
    });
    elms[i].addEventListener("click", function (evt) {
      if (elms[i].detaset != null && elms[i].detaset.move == "true")
        evt.stopPropagation();
    });
  }
  document.addEventListener("mousemove", function (evt) {
    if (target != null && target.dataset.down == "true") {
      evt.preventDefault();
      let move_x = parseInt(target.dataset.x) - evt.clientX;
      let move_y = parseInt(target.dataset.y) - evt.clientY;
      if (move_x !== 0 || move_y !== 0) {
        target.dataset.move = "true";
      } else {
        return;
      }
      target.scrollLeft = parseInt(target.dataset.scrollleft) + move_x;
      target.scrollTop = parseInt(target.dataset.scrolltop) + move_y;
      evt.stopPropagation();
    }
  });
  document.addEventListener("mouseup", function (evt) {
    if (target != null && target.dataset.down == "true") {
      target.dataset.down = "false";
      evt.stopPropagation();
    }
  });
}
